import { createStylesContext } from '@salesforce/retail-react-app/app/components/shared/ui'

const [StoreLocatorStylesProvider, useStoreLocatorStyles] = createStylesContext('StoreLocator')

export { StoreLocatorStylesProvider, useStoreLocatorStyles }
